import { render, staticRenderFns } from "./PurchaseInfoDefault.vue?vue&type=template&id=42503575&scoped=true"
import script from "./PurchaseInfoDefault.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfoDefault.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInfoDefault.vue?vue&type=style&index=0&id=42503575&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42503575",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42503575')) {
      api.createRecord('42503575', component.options)
    } else {
      api.reload('42503575', component.options)
    }
    module.hot.accept("./PurchaseInfoDefault.vue?vue&type=template&id=42503575&scoped=true", function () {
      api.rerender('42503575', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseInfoDefault.vue"
export default component.exports